module.exports = __webpack_public_path__ + "img/Precojusto_dcf.024f13ca.svg";